const v = require('voca');
export const getBuilderURL = (version) => {
  let domainName = window.location.hostname;
  let redirectUrl = `https://${domainName}/`;
  if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
    redirectUrl = `http://${domainName}:6075/`;
  } else if (process.env.REACT_APP_ENVIRONMENT === 'STAGING') {
    domainName = domainName.replace('builderc.webkonnect.xyz', 'builder.webkonnect.xyz');
    redirectUrl = `https://${domainName}/`;
  } else {
    domainName = domainName.replace('builderc.mydrapcode.com', 'builder.mydrapcode.com');
    redirectUrl = `https://${domainName}/`;
  }
  return redirectUrl;
};

export const createFieldKey = (fieldName, trim = false) => {
  if (fieldName) {
    let fieldNameKey = `{{${fieldName}}}`;
    if (!trim) {
      return fieldNameKey;
    }
    return v.truncate(fieldNameKey, 60, '(...)');
  }
};
